export default {
  'tracking:page-title': 'Versandverfolgung',
  'tracking:title': 'Sendungsverfolgung',
  'tracking:status:1': '1. Deine Bestellung im Onlineshop war erfolgreich',
  'tracking:status:2':
    '2. {employee} kümmert sich aktuell in unserem Versandlager um deine Bestellung',
  'tracking:status:3':
    '3. Deine Bestellung ist versandfertig. Sobald das Versandunternehmen dein Paket empfangen hat, erhältst du nachfolgend detaillierte Informationen zum weiteren Sendungsverlauf:',
};
